<template>
  <!-- 人员状态 -->
  <div class="statepersonnel">

    <table class="mytable">
      <thead>
        <tr>
          <th >人员姓名</th>
          <th >状态</th>
          <th >驾驶车辆编号</th>
          <th >起止地点</th>
          <th>

            <i @click="addRow" style="font-size: 1.2rem;font-weight: 600;cursor:pointer;position: relative;top: 0.05rem;color: #00ffff;" class="el-icon-circle-plus-outline"></i>

          </th>

        </tr>
      </thead>
      <tbody>


        <tr v-for="(item,i) in tableData" :key='i'>
          <td>
            <el-input  v-model="item.driverName" placeholder="请输入 "></el-input>
          </td>
          <td>
            <el-select v-model="item.status" placeholder="请选择">
              <el-option label="空闲" :value="1"></el-option>
              <el-option label="忙碌" :value="2"></el-option>
              <el-option label="轮休" :value="3"></el-option>
              <el-option label="请假" :value="4"></el-option>
            </el-select>
          </td>
          <td>
            <el-input v-model="item.carNum" placeholder="请输入"></el-input>
          </td>
          <td>
            <el-input v-model="item.address" placeholder="请输入"></el-input>
          </td>

          <td style="width: 6rem;text-align: center;">
            <i @click="del(item,i)" class="el-icon-remove-outline" style="font-size: 1.2rem;line-height: 1.8rem;color: #f00;font-weight: 600;cursor: pointer;"></i>
          </td>
        </tr>



      </tbody>
    </table>
    <p v-if="!tableData.length" style="text-align: center;margin-top: 5rem;">暂无数据<p>


    <div style="margin-top: 2rem;">
      <el-button @click="save" size="small" type="primary">保存设置</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/transportation/statepersonnel'
export default {
  components: {},
  data() {
    return {
      tableData: [
     
      ],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    addRow() {
      this.tableData.push({
        address: '', //起止地点
        carNum: '', //驾驶车辆编号
        driverName: '', //人员姓名
        status: 1, //1:空闲 2：忙碌 3：轮休 4：请假
      })
    },
    getlist() {
      api
        .list({
          params: {
            limit: 100,
            page: 1,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            // if (res.data.list.length) {
              this.tableData = res.data.list
            // }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    save() {
      api.save(this.tableData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
          this.getlist()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    del(item, i) {
      this.$confirm(`确定删除数据？`).then(() => {
        if (item.id) {
          for (const iterator of this.tableData) {
            if (iterator.id === undefined) {
              return this.$message.warning(
                '还有未保存的数据,请先保存后再删除！'
              )
            }
          }

          api.del([item.id]).then((res) => {
            if (res.code === 10000) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
            this.getlist()
          })
        } else {
          this.tableData.splice(i, 1)
        }
      })
    },
  },
}
</script>

<style lang="less">
.statepersonnel { padding-top: 10px;
  width: 70%;
}
</style>